import React from 'react'
import { Link as RouterLink, useNavigate, Outlet } from 'react-router-dom'
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Button,
  Container,
  IconButton
} from '@mui/material'
import { AccountCircle, ArrowBack } from '@mui/icons-material'

const PublicLayout = () => {
  const navigate = useNavigate()
  const isHome = window.location.pathname === '/publico'

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#fafafa' }}>
      <AppBar position="sticky" elevation={1} sx={{ bgcolor: 'white', color: 'text.primary' }}>
        <Toolbar sx={{ gap: 1.5 }}>
          {!isHome && (
            <IconButton color="inherit" onClick={() => navigate('/publico')} aria-label="Volver al inicio">
              <ArrowBack />
            </IconButton>
          )}
          <Box
            component="img"
            src="/ensas_logo.png"
            alt="Logo ENSAS"
            sx={{ height: 40, width: 40, objectFit: 'contain' }}
          />
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.1 }}>
              Escuela Normal Superior del Alto Sinú
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Sistema de Gestión de Calidad — Consulta de Procedimientos
            </Typography>
          </Box>
          <Button
            color="primary"
            component={RouterLink}
            to="/login"
            startIcon={<AccountCircle />}
            sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
          >
            Ingreso interno
          </Button>
        </Toolbar>
      </AppBar>

      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>

      <Box
        component="footer"
        sx={{
          py: 3,
          mt: 4,
          textAlign: 'center',
          borderTop: '1px solid #eee',
          bgcolor: 'white',
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="body2" color="text.secondary">
            Escuela Normal Superior del Alto Sinú — Sistema de Gestión de Calidad (SGC)
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Documentos de consulta pública
          </Typography>
        </Container>
      </Box>
    </Box>
  )
}

export default PublicLayout
